<template>
  <div class="flex flex-1 flex-col justify-between dark:text-gray-500">
    <p class="text-caption-s text-left !leading-[23.1px]">
      Directories <br />
      • <b>Unlimited directories</b> <br />
      <br />

      Screenshots <br />
      • Cloud screenshots <br />
      • Copy/Save locally <br />
      • Annotate and Markups <br />
      • Comment notifications <br />
      • Text recognition (OCR) <br />
      <br />

      Videos and GIFs <br />
      <span class="text-left">
        • Cloud Videos (<b class="dark:text-white">8k/60fps</b>) <br />
        • Copy/Save locally (<b class="dark:text-white">8k/60fps</b>) <br />
        • Cloud GIFs (<b class="dark:text-white">Full HD</b>) <br />
        • Copy/Save locally GIFs <br />
        • Webcam Video <br />
        • Annotate and Markups <br />
      </span>
      <br />

      Files <br />
      <span class="text-left"> • File sharing (<b class="dark:text-white">15GB per file</b>) </span>
    </p>
  </div>
</template>

<script setup lang="ts"></script>
